// Front-end flag keys
// Note: Back end registry is at feature-switch-registry.ts in the API package.

export enum EFeatureFlag {
  PlanningCalculator = 'planning-calculator',
  ExperimentDetailExtendedPrecisionKey = 'experiment-detail-extended-precision',
  UseUtcKey = 'use-utc',
  DefaultTimezone = 'default-timezone',
  FeatureFlagAuditLog = 'feature-flag-audit-log',
  ExperimentMetricDisplayAbsoluteLift = 'experiment-metric-display-absolute-lift',
  AllowMetricManualRefresh = 'allow-metric-manual-refresh',
  AllowFullManualRefresh = 'allow-full-manual-refresh',
  BayesianDetailsLossForControl = 'loss-for-control-in-bayesian-details',
  DefinitionsSkipRun = 'definitions-skip-run',
  UnlimitedEnvironments = 'unlimited-environments',
  FeatureFlagNotification = 'feature-flag-notification',
  HoldoutsAnalysisOnly = 'holdouts-analysis-only',
  HoldoutsEndToEnd = 'holdouts-end-to-end',
  KillAllQueriesButton = 'kill-all-queries-button',
  UserTeams = 'user-teams',
  TeamExperimentPermissions = 'team-experiment-permissions',
  TeamMetricPermissions = 'team-metric-permissions',
  WorkflowSettingsPage = 'workflow-settings-page',
  DisableNotifications = 'disable-notifications',
  EmailNotifications = 'email-notifications',
  FeatureFlagApproval = 'feature-flag-approval',
  CountDistinctAgg = 'count-distinct-agg',
  ExperimentRealTimeMetricsUi = 'experiment-live-metrics-ui',
  ExperimentRealTimeMetricsManualRecompute = 'experiment-live-metrics-manual-recompute',
  ExperimentPropertyAnalysis = 'property-analysis-tab',
  FeatureFlagSemVer = 'feature-flag-semver-support',
  ShowTeamsPickerInterstitial = 'show-teams-picker-interstitial',
  FeatureFlagTeamPermissions = 'feature-flag-team-permissions',
  KnowledgeBase = 'knowledge-base',
  Layers = 'layers',
  InviteUser = 'invite-user',
  MultipleExperimentAllocation = 'multiple-experiment-allocation',
  BanditsUI = 'bandits-ui',
  SourceDiagnostics = 'source-diagnostics',
  SearchBarV2 = 'search-bar-v2',
  BigQueryOAuth = 'big-query-oauth',
  BigQueryIdentityPool = 'big-query-identity-pool',
  FFAudiences = 'ff-audiences',
  AdminMetricExportLog = 'admin-metric-export-log',
  PipelineMetricFilterDimensions = 'pipeline-metric-filter-dimensions',
  DatePartitionKeyUX = 'date-partition-key-ux',
  WebhooksAdminTab = 'webhooks-admin-tab',
  PipelineVisibilityWarehouseLeftNav = 'pipeline-visibility-warehouse-left-nav',
  FactLaggingTable = 'fact-lagging-table',
  MetricWindows = 'metric-windows',
  TeamScorecards = 'team-scorecards',
  TeamScorecardsQualityCard = 'team-scorecards-quality-card',
  TeamScorecardsExperimentPerformance = 'team-scorecards-experiment-performance',
  ClusteredAnalysis = 'clustered-analysis',
  FeatureFlagTrials = 'feature-flag-trials',
  SecondaryId = 'secondary-id',
  SecondaryIdMetricCollections = 'secondary-id-metric-collections',
  FFDetailsPageEnvironmentsSidebar = 'ff-details-page-environments-sidebar',
  NonInferiorityMetrics = 'non-inferiority-metrics',
  FeatureFlagScheduledRollouts = 'feature-flag-scheduled-rollouts',
  LastValueAggregation = 'last-value-aggregation',
  PositiveOnlyWinsorizationBasis = 'positive-only-winsorization-basis',
  NoKnowledgeBaseExplores = 'no-knowledge-base-explores',
  AnalysisWindowDatesOnly = 'analysis-window-dates-only',
  AssignmentRename = 'assignment-rename',
  NewAnalysisCreateFlow = 'new-analysis-create-flow',
  PercentileMetrics = 'percentile-metrics',
  FFDependentFlags = 'dependent-flags',
  IncrementalEffectView = 'incremental-effect-view',
  ExperimentMetricViewDefault = 'experiment-metric-view-default',
  MetricWinsorFixedValue = 'metric-winsor-fixed-value',
  OptInMetricProperties = 'opt-in-metric-properties',
  FlagOverrides = 'flag-overrides',
  OptInMetricPropertiesDisableFactLevelConfig = 'opt-in-metric-properties-disable-fact-level-config',
  AutofillAnalysisDates = 'autofill-analysis-dates',
  AverageExposureLabel = 'average-exposure-label',
  MinimumConfidenceLevel = 'minimum-confidence-level',

  // flagging
  FeatureFlagTags = 'feature-flag-tags',
  ProtocolsMilestoneOne = 'protocols-milestone-1',
  FeatureFlagMonitoringUI = 'feature-flag-monitoring-ui',
  WaterfallPhaseTwo = 'ff-ux-assignment-waterfall-phase-2',
  LiveSubjectTesting = 'feature-flag-live-subject-testing',
  NavigationImprovements = 'navigation-improvements',
  FlaggingEnvironmentAutomatedValidation = 'flagging-environment-automated-validation',
  SelectiveHoldouts = 'selective-holdouts',
  QuasiExperimentsM0 = 'quasi-experiments-m0',
  QuasiExperimentTestDesign = 'quasi-experiment-test-design',
  QuasiExperimentCreateFlowV2 = 'quasi-experiment-create-flow-v2',
  DisableRandomizationInFFCreation = 'disable-randomization-in-ff-creation',
  BlockTrafficSplitChanges = 'block-traffic-split-changes',

  RunningOverviewCard = 'running-overview-card',
  DisableMetricPropertyExplores = 'disable-metric-property-explores',

  RecommendedDecision = 'recommended-decision',
  PredefinedTargetingAttributes = 'predefined-attributes',
  ExperimentTimelineView = 'experiment-timeline-view',
  ExploreChartMaxDimensions = 'explore-chart-max-dimensions',
  ExploreChartDaysSinceAssignment = 'explore-chart-days-since-assignment',
  Cupac = 'cupac',

  SwitchbackAnalysis = 'switchback-testing-ui',
  SwitchbackSDKSupport = 'switchback-sdk-support',

  EnforceSCIM = 'enforce-scim',
  SdkEventLogging = 'sdk-event-logging',

  MultivariateComparisonView = 'multivariate-comparison-view',
  ConversionFromPriorStepFirst = 'conversion-from-prior-step-first',
  DuplicateMetricsWhenAddingMEE = 'duplicate-metrics-when-adding-mee',

  NewFFCreationFlow = 'new-ff-creation-flow',
  PipelineNoFullRefreshOnSqlChange = 'pipeline-no-full-refresh-on-sql-change',
  PipelineGlobalImpactCountDistinct = 'pipeline-global-impact-count-distinct',
  WarehouseVisibilityUI = 'warehouse-visibility-ui',
  ExperimentTags = 'experiment-tags',
  RequireTagsDuringExperimentCreation = 'require-tags-during-experiment-creation',
  RequireTagsDuringFlagCreation = 'require-tags-during-flag-creation',
  AllowReusingFlagKeys = 'allow-reusing-flag-keys',
  LockApiCreatedFlagVariations = 'lock-api-created-flag-variations',
  InteractionEffectDetection = 'interaction-effect-detection',
  DefaultEntitySelectionAnnouncementEnabled = 'default-entity-selection-announcement-enabled',
  ShowDatadogTransitionBanner = 'show-datadog-transition-banner',
  CombinedAssignmentCreation = 'combined-assignment-creation',
  ArchiveBanditsEnabled = 'archive-bandits-enabled',
  CheckPerformanceCardByMetricDesiredChange = 'check-performance-card-by-metric-desired-change',
  EndBasedOnPrecisionProgress = 'end-based-on-precision-progress',
  ShowChatInSidebar = 'show-chat-in-sidebar',
  LeadingVariantByMetricValue = 'determine-leading-variant-by-value',

  ExpandedNotifications = 'expanded-notifications',

  WarehouseTableCleanupAutomation = 'warehouse-table-cleanup-automation',

  // Metadata flags
  EnableMetadata = 'enable-metadata',

  // Datadog-powered flags
  EppoByDatadogLogo = 'show-eppo-by-datadog-logo',
  MaskUpdatesButton = 'mask-updates-button',
  NavbarAATest = 'navbar-aa-test',
  CupedForSwitchbacks = 'cuped-for-switchbacks',
  PipelineRuntimeHoursFirst = 'pipeline-runtime-hours-first',
  PipelineInsightsEnabled = 'pipeline-optimization-insights', // Dummy flag that will cause an error
  NewAiModel = 'new-ai-model',
  ConfirmJsonVariantValueEdit = 'confirm-json-variant-value-edit',
  LockJsonVariationFullscreenEditor = 'lock-json-variation-fullscreen-editor',
  EppoMigrationSdkKeyPermission = 'eppo-migration-sdk-key-permission',
}
